import { useEffect, useState, useLayoutEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Carousel from "react-multi-carousel";
import ArtistCardLink from "./CardLink";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import Hero from "../../../components/Hero";
import back from "../../../assets/back.png";
import facebook_icon from "../../../assets/svg/facebook.svg";
import twitter_icon from "../../../assets/svg/twitter.svg";
import youtube_icon from "../../../assets/svg/youtube.svg";
import instagram_icon from "../../../assets/svg/instagram.svg";
import amazon_icon from "../../../assets/svg/amazon_icon.svg";
import apple_icon from "../../../assets/svg/apple_icon.svg";
import soundcloud_icon from "../../../assets/svg/soundcloud_icon.svg";
import spotify_icon from "../../../assets/svg/spotify_icon.svg";
import youtubemusic_icon from "../../../assets/svg/youtubemusic_icon.svg";
import play from "../../../assets/svg/play.svg";
import pause from "../../../assets/svg/pause.svg";
import { TitleComponent } from "../../../TitleComponent";
import useSingleArtist from "../../../custom-hooks/useSingleArtist";
import useArtists from "../../../custom-hooks/useArtists";


const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
    partialVisibilityGutter: 50,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1250 },
    items: 3,
    partialVisibilityGutter: 50,
  },
  tablet: {
    breakpoint: { max: 1250, min: 770 },
    items: 2,
    partialVisibilityGutter: 50,
  },
  mobile: {
    breakpoint: { max: 769, min: 0 },
    items: 1,
    partialVisibilityGutter: 30,
  },
};

const Artist = () => {
  const { id } = useParams();
  const [artist, isLoading] = useSingleArtist(id)
  const [allArtists] = useArtists();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const imageUrl = artist?.artistImage?.fields?.file?.url;
  const imageTitle = artist?.fields?.artistImage?.fields?.fileName;
  const title= artist?.title;
  const text = artist?.text;
  const about = artist?.about;
  
  return (
    <>
      <TitleComponent
        title={title}
        description={about && about.substring(0, 100) + "..."}
      />
      <Header />
      <div className="relative">
        <div className="absolute z-50 left-24 mobile:top-16 mobile:left-6 sm:left-6 sm:top-20 md:left-16 md:top-16 top-40">
          <Link
            className="flex gap-2 items-center cursor-pointer"
            to={"/artists"}
          >
            <img src={back} alt="back" />
            <p className="font-poppins font-normal text-lg leading-7 text-green">
              All Artists
            </p>
          </Link>
        </div>
        <Hero
          heading={title ? title : "Meet Our Artist"}
          Style="max-w-4xl font-poppins font-normal text-3xl leading-normal text-center text-white mobile:leading-7 mobile:px-5 mobile:text-xl sm:px-5 sm:text-2xl"
        />
      </div>

      <section className="max-w-6xl mx-auto md:mx-4 mobile:mx-4 sm:mx-4">
        {isLoading ? (
          <div
            class="w-16 h-16 mx-auto rounded-full animate-spin flex items-center justify-center border-4 border-dashed border-white border-t-transparent"></div>
        ) : (
          <div className="flex gap-6 mobile:flex-col sm:flex-col">
            <div className="flex-1 mx-auto">
              <img src={imageUrl} alt={imageTitle} className="w-80 h-96 object-cover opacity-70" />
              <ul className="mt-6 flex items-center gap-4">
                {artist.links && artist.links.instagram ? (
                  <li>
                    <a
                      href={artist.links.instagram}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={instagram_icon}
                        alt="Instagram"
                        className="hover:text-green"
                      />
                    </a>
                  </li>
                ) : null}
                {artist.links && artist.links.facebook ? (
                  <li>
                    <a
                      href={artist.links.facebook}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={facebook_icon} alt="Facebook" />
                    </a>
                  </li>
                ) : null}
                {artist.links && artist.links.twitter ? (
                  <li>
                    <a
                      href={artist.links.twitter}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={twitter_icon} alt="Twitter" />
                    </a>
                  </li>
                ) : null}
                {artist.links && artist.links.youtube ? (
                  <li>
                    <a
                      href={artist.links.youtube}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={youtube_icon} alt="Youtube" />
                    </a>
                  </li>
                ) : null}
              </ul>
            </div>

            <div className="flex-1 mx-auto flex flex-col">
              <h3 className="font-mulish text-lg text-gray-400 font-semibold">
                {text}
              </h3>
              <p className="mt-5 font-mulish text-lg text-white leading-7">
                {about}
              </p>
              {artist.links &&
              (artist?.links?.spotify ||
                artist?.links?.soundcloud ||
                artist?.links?.appleMusic ||
                artist?.links?.youtubeMusic ||
                artist?.links?.amazonMusic) ? (
                <div className="mt-10">
                  <h2 className="font-poppins text-white font-bold">
                    Listen On
                  </h2>
                  <ul className="flex gap-3 mt-2">
                    {artist.links && artist.links.spotify ? (
                      <li>
                        <a
                          href={artist.links.spotify}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={spotify_icon} alt="Spotify" />
                        </a>
                      </li>
                    ) : null}
                    {artist.links && artist.links.soundcloud ? (
                      <li>
                        <a
                          href={artist.links.soundcloud}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={soundcloud_icon} alt="Soundcloud" />
                        </a>
                      </li>
                    ) : null}
                    {artist.links && artist.links.appleMusic ? (
                      <li>
                        <a
                          href={artist.links.appleMusic}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={apple_icon} alt="Apple Music" />
                        </a>
                      </li>
                    ) : null}
                    {artist.links && artist.links.youtubeMusic ? (
                      <li>
                        <a
                          href={artist.links.youtubeMusic}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={youtubemusic_icon} alt="Youtube Music" />
                        </a>
                      </li>
                    ) : null}
                    {artist.links && artist.links.amazonMusic ? (
                      <li>
                        <a
                          href={artist.links.amazonMusic}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={amazon_icon} alt="Amazon Music" />
                        </a>
                      </li>
                    ) : null}
                  </ul>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </section>

      {artist?.sampleTracks && artist.sampleTracks.length !== 0 ? (
        <section>
          <h3 className="my-16 text-white font-bold text-3xl font-poppins text-center">
            Sample Tracks
          </h3>
          <SampleTrackContainer sampleTracks={artist?.sampleTracks} />
        </section>
      ) : null}

      {/* <section className="mt-28">
        <h3 className="mb-16 text-white font-bold text-3xl font-poppins text-center">
          Other Artists
        </h3>
        <Carousel
          responsive={responsive}
          additionalTransfrom={0}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          partialVisible
          className="mx-auto max-w-7xl md:mx-4 mobile:mx-4 sm:mx-4"
        >
          {allArtists.map((data, index) => (
            <ArtistCardLink data={data} key={index} />
          ))}
        </Carousel>
      </section> */}

      <div className="max-w-7xl mx-auto my-20 mobile:mx-4 sm:mx-4 md:mx-4 rounded-2xl bg-wave1 bg-no-repeat py-10 bg-cover">
        <div className="flex flex-col justify-center items-center">
          <h2 className="font-poppins font-bold text-white text-4xl leading-relaxed text-center max-w-3xl mb-5 mobile:leading-9 mobile:text-2xl sm:text-3xl">
            If you are an artist, help us create great music that can elevate
            creator’s content.
          </h2>
          <p className="font-normal font-mulish text-3xl leading-9 text-white opacity-80 mb-4 text-center mobile:text-2xl">
            Submit your tracks, make some money.
          </p>
          <a
            rel="noreferrer"
            type="button"
            className="focus:outline-none text-black bg-green focus:ring-4 focus:ring-green-300 shadow-button font-medium font-poppins rounded-xl text-base px-20 py-2.5 my-4 hover:shadow-button1"
            href="https://forms.gle/kWVYEWbQcm6xkUKn6"
            target="_blank"
          >
            Join the Crew
          </a>
        </div>
      </div>

      <section className="max-w-7xl mx-auto pt-5">
        <Footer />
      </section>
    </>
  );
};

function SampleTrackContainer({ sampleTracks }) {
  const audioElements = [];

  return (
    <div className="max-w-7xl rounded-xl relative backdrop-blur bg-white bg-opacity-10 mx-auto md:mx-4 mobile:mx-4 sm:mx-4">
      <div className="absolute -top-32 -left-10 w-56 h-56 bg-pink-npink opacity-20 blur-3xl -z-10" />
      <div className="absolute -bottom-32 right-0 w-56 h-56 bg-blue-500 opacity-20 blur-3xl -z-10" />
      <div className="p-9 text-white text-center mobile:p-4 sm:p-4">
        <div className="opacity-60 font-poppins font-medium mb-4 px-2 grid grid-cols-tracks mobile:hidden sm:hidden gap-4">
          <span></span>
          <span>TITLE</span>
          <span>GENRE</span>
          <span></span>
          <span>DURATION</span>
        </div>
        {sampleTracks?.map((track, index) => (
          <SampleTrack
            key={index}
            trackName={track?.fields?.title}
            genre={track?.fields?.description}
            audio={track?.fields?.file?.url}
            showBorderInMobile={!(index === 0)}
            audioElements={audioElements}
          />
        ))}
      </div>
    </div>
  );
}

function SampleTrack({ trackName, genre, audio, showBorderInMobile = true, audioElements }) {
  const [track] = useState(new Audio(encodeURI(audio)));
  const [playingAudio, setPlayingAudio] = useState(false);
  const [trackDuration, setTrackDuration] = useState(0);
  const [trackProgress, setTrackProgress] = useState(0);
  const [trackError, setTrackError] = useState(null);

  useEffect(() => {
    audioElements.push(track);

    function loadedmetadataHandler() {
      setTrackDuration(formatDuration(track.duration));
    }

    function endedHandler() {
      setTrackProgress(0);
      setPlayingAudio(false);
    }

    function timeupdateHandler() {
      setTrackProgress(track.currentTime / track.duration);
    }

    function errorHandler() {
      setTrackError("Error occured!");
    }

    function playHandler(e) {
      setPlayingAudio(true);
      const audios = audioElements;
      for (let i = 0, len = audios.length; i < len; i++) {
        if (audios[i] !== e.target) {
          audios[i].pause();
        }
      }
    }

    function pauseHandler() {
      setPlayingAudio(false);
    }

    track.addEventListener("loadedmetadata", loadedmetadataHandler);
    track.addEventListener("ended", endedHandler);
    track.addEventListener("timeupdate", timeupdateHandler);
    track.addEventListener("error", errorHandler);
    track.addEventListener("play", playHandler);
    track.addEventListener("pause", pauseHandler);

    return () => {
      track.removeEventListener("loadedmetadata", loadedmetadataHandler);
      track.removeEventListener("ended", endedHandler);
      track.removeEventListener("timeupdate", timeupdateHandler);
      track.removeEventListener("error", errorHandler);
      track.removeEventListener("play", playHandler);
      track.removeEventListener("pause", pauseHandler);
    };
  }, [track, audioElements]);

  function formatDuration(durationInSec) {
    const minutes = Math.floor(durationInSec / 60);
    const seconds = Math.floor(durationInSec % 60);
    const duration = `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
    return duration;
  }

  function toggleAudio() {
    if (!playingAudio) {
      track.play();
    } else {
      track.pause();
    }
  }

  useEffect(() => {
    return () => {
      track.pause();
    };
  }, [track]);

  return (
    <div
      className={`px-2 font-mulish border-t border-gray-600 py-4 items-center gap-4 grid grid-cols-tracks sm:grid-cols-tracks-mobile mobile:grid-cols-tracks-mobile break-words ${
        !showBorderInMobile ? "mobile:border-0 sm:border-0" : ""
      }`}
    >
      <div className="relative">
        <img
          src={playingAudio ? pause : play}
          alt={"music"}
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer"
          onClick={toggleAudio}
        />
      </div>
      <span className="font-poppins font-medium">{trackName}</span>
      <span className="opacity-60 mobile:hidden sm:hidden">{genre}</span>
      <CustomProgressBar progress={trackProgress} />
      {!trackError ? (
        <span className="opacity-60">{trackDuration ? trackDuration : "Loading..."}</span>
      ) : (
        <span className="opacity-60">Error fetching track</span>
      )}
    </div>
  );
}

function CustomProgressBar({ progress }) {
  return (
    <div class="w-full bg-gray-400 rounded-full h-1 overflow-hidden mobile:hidden sm:hidden">
      <div class="bg-pink-500 h-1 rounded-full" style={{ width: `${progress * 100}%` }}></div>
    </div>
  );
}

export default Artist;
